import { faker } from '@faker-js/faker';

import type { OneOffPaymentNoticeDeleteResponse } from '../types/OneOffPaymentNoticeDeleteResponse';

export function createOneOffPaymentNoticeDeleteResponse(
  data: NonNullable<Partial<OneOffPaymentNoticeDeleteResponse>> = {}
): NonNullable<OneOffPaymentNoticeDeleteResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
